export const authCode={
  'code': ''
};